<div class="header">
  <h1>Where are you hopping?</h1>
  <a [routerLink]="'../'">
    <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/x.svg"></svg-icon>
  </a>
</div>

<div class="explore-main">
  <form [formGroup]="searchForm">
    <div class="explore-inputs" (outsideClick)="activeInput = undefined">
      <app-where-mobile formControlName="where" id="where" (mousedown)="activeInput = 'where'" [(activeInput)]="activeInput"></app-where-mobile>
      <app-when-mobile formControlName="when" id="when" (mousedown)="activeInput = 'when'" [(activeInput)]="activeInput"></app-when-mobile>
      <app-who-mobile formControlName="who" id="who" (mousedown)="activeInput = 'who'" [(activeInput)]="activeInput"></app-who-mobile>
    </div>
  </form>
</div>

<ng-container *ngIf="!activeInput || activeInput === 'who' || activeInput === 'where'" >
  <div class="fixed-test">
    <button class="btn btn-large" [disabled]="!searchForm.get('where')?.value && !searchForm.get('when')?.value && !searchForm.get('who')?.value" (click)="clear()">
      <ng-container i18n>Clear all</ng-container>
    </button>
    <!-- <button class="btn btn-theme btn-large" [disabled]="!searchForm.valid || searchForm.errors" (click)="doSearch()">
      <span>Search</span>
    </button> -->
    <ng-container *ngIf="isHostel(searchForm.value.where); else pwa">
      <a class="btn btn-theme btn-large" [routerLink]="['/hostels', searchForm.value.where.id]" [queryParams]="searchParams | async">
        <ng-container i18n>Explore</ng-container>
      </a>
    </ng-container>
    <ng-template #pwa>
      <a class="btn btn-theme btn-large" [href]="pwaUrl | async">
        <ng-container i18n>Explore</ng-container>
      </a>
    </ng-template>
    <!-- <a class="btn btn-theme btn-large" [ngClass]="{'disabled': !searchForm.valid || searchForm.errors}" [href]="pwaUrl | async" target="_blank" >
      <span>Explore</span>
    </a> -->
  </div>
</ng-container>
